import Permissions from '@/common/permissions';
import {useHasAccess} from '@/modules/core';

import {useGetEnrollments} from '../hooks/useGetEnrollment';

export const useExcessContributionAvailable = (employeeId?: string) => {
  const hasPermission = useHasAccess([{ permission: Permissions.MANAGE_EXCESS_CONTRIBUTIONS }]);
  const { isHSAExists } = useGetEnrollments({ employeeId });
  return {
    isExcessContributionAvailable: Boolean(isHSAExists && hasPermission),
  };
};